export default __webpack_public_path__ + "static/media/pen.d16dd847.png";